/**
 * Парсит ISO 8601 duration (например: "PT2H28M19S") в общее количество минут
 */
export const parseISO8601Duration = (duration: string): number => {
  const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?/);

  if (!match) {
    console.warn(`Invalid ISO 8601 duration format: ${duration}`);
    return 0;
  }

  const hours = parseInt(match[1] || "0", 10);
  const minutes = parseInt(match[2] || "0", 10);
  const seconds = parseFloat(match[3] || "0");

  return hours * 60 + minutes + Math.ceil(seconds / 60);
};

/**
 * Форматирует минуты в читаемый формат "X ч Y мин"
 */
const formatDurationMinutes = (totalMinutes: number): string => {
  if (totalMinutes === 0) return "0 мин";

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours === 0) {
    return `${minutes} мин`;
  } else if (minutes === 0) {
    return `${hours} ч`;
  } else {
    return `${hours} ч ${minutes} мин`;
  }
};

/**
 * Суммирует длительности всех шагов маршрута и возвращает в читаемом формате
 */
export const calculateTotalRouteDuration = (
  legs: Array<{ steps: Array<{ duration: string }> }>,
): string => {
  const totalMinutes = legs.reduce<number>((legTotal, leg) => {
    const legMinutes = leg.steps.reduce<number>((stepTotal, step) => {
      return stepTotal + parseISO8601Duration(step.duration);
    }, 0);
    return legTotal + legMinutes;
  }, 0);

  return formatDurationMinutes(totalMinutes);
};
